import { invalidateAcpClientState } from '../ensure-acp-client.js';
import type { AcpManagerContext } from './acp-manager-context.js';

export async function disconnectAll(ctx: AcpManagerContext): Promise<void> {
  await Promise.all(
    [...ctx.acpAgents.values()].map(async (state) => {
      try {
        await state.acpHandle?.disconnectGracefully();
      } catch {
        /* ignore */
      }
      invalidateAcpClientState(state);
    }),
  );
  ctx.acpAgents.clear();
  ctx.runDispatch.clear();
  ctx.pendingCancelRunIds.clear();
}
